import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { MAX_OVERRIDE_REASON_LENGTH } from "../lib/doubleBooking"

/**
 * The "double-book anyway" panel: what the server said, and the reason the override needs. Shown only
 * to somebody holding `appointments:manage`, and only once the server (or a picker that already knew)
 * has said the host is booked then. The caller owns the button that resubmits with the override.
 */
export function DoubleBookOverrideSection({ id, message, reason, onReasonChange, disabled }: {
  /** Unique within the dialog, for the textarea's label. */
  id: string
  /** Why the override is on offer — the server's refusal, or the picker's own warning. */
  message: string
  reason: string
  onReasonChange: (reason: string) => void
  disabled?: boolean
}) {
  return (
    <section className="rounded-md border border-amber-300 bg-amber-50 p-3 dark:bg-amber-950/30">
      <p className="text-sm font-medium">{message}</p>
      {/* Said before the click, because it is the point: the override is attributable, and it is the
          one exception to "one appointment per host at a time". */}
      <p className="mt-1 text-xs text-muted-foreground">
        You can double-book this host anyway. They will have two appointments at once; the booking is
        marked as a double booking and recorded against your name with the reason below.
      </p>
      <Label htmlFor={id} className="mt-3 block text-xs font-medium">
        Reason for double-booking <span aria-hidden className="text-destructive">*</span>
      </Label>
      <Textarea
        id={id}
        className="mt-1.5"
        rows={2}
        maxLength={MAX_OVERRIDE_REASON_LENGTH}
        value={reason}
        disabled={disabled}
        placeholder="e.g. Two adults from one household, seen together"
        onChange={event => onReasonChange(event.target.value)}
      />
    </section>
  )
}
